// extracted by mini-css-extract-plugin
export default {"ContentFeatureTimeResetPager":"ContentFeatureTimeResetPagerkUMk1","contentFeatureTimeResetPager":"ContentFeatureTimeResetPagerkUMk1"};